module.exports = __webpack_public_path__ + "img/11.14500c8f.jpg";